export const MUTATION_GROUP = 'teamFields' as const;
